"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = (0, tslib_1.__importStar)(require("react"));
const lib_1 = require("../../lib");
const Portal_1 = require("../Portal");
const ModalBody_1 = require("./ModalBody");
const ModalFooter_1 = require("./ModalFooter");
const ModalHeader_1 = require("./ModalHeader");
const Spinner_1 = require("../Spinner");
const getChildren = (children) => {
    let body, header, footer = null;
    let otherChildren = [];
    react_1.default.Children.forEach(children, (child) => {
        if (child) {
            switch (child.type) {
                case ModalHeader_1.ModalHeader:
                    header = child;
                    break;
                case ModalBody_1.ModalBody:
                    body = child;
                    break;
                case ModalFooter_1.ModalFooter:
                    footer = child;
                    break;
                default:
                    otherChildren.push(child);
                    break;
            }
        }
    });
    return { body, header, footer, otherChildren };
};
const ModalComponent = ({ children, open, className, size, loading, }) => {
    const { body, header, footer, otherChildren } = getChildren(children);
    (0, react_1.useEffect)(() => {
        if (open && !document.body.classList.contains("modal-open")) {
            document.body.classList.add("modal-open");
        }
        else {
            document.body.classList.remove("modal-open");
        }
        return () => {
            document.body.classList.remove("modal-open");
        };
    }, [open]);
    if (!open)
        return null;
    return ((0, jsx_runtime_1.jsx)(Portal_1.Portal, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.classnames)((0, lib_1.bem)("modal", "--visible", (0, lib_1.use)(size, `--${size}`)), className) }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, lib_1.classnames)((0, lib_1.bem)("modal__dialog", (0, lib_1.use)(size, `--${size}`))) }, { children: [loading && (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, {}, void 0), header, body || otherChildren, footer] }), void 0) }), void 0) }, void 0));
};
/**
 * Modal component
 *
 * @visibleName Modal
 */
class Modal extends react_1.default.Component {
    render() {
        return (0, jsx_runtime_1.jsx)(ModalComponent, Object.assign({}, this.props), void 0);
    }
}
exports.Modal = Modal;
Modal.Header = ModalHeader_1.ModalHeader;
Modal.Body = ModalBody_1.ModalBody;
Modal.Footer = ModalFooter_1.ModalFooter;
//# sourceMappingURL=Modal.js.map